import { render, staticRenderFns } from "./UserActivityWidget.vue?vue&type=template&id=e4d4baee&scoped=true&"
import script from "./UserActivityWidget.vue?vue&type=script&lang=js&"
export * from "./UserActivityWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityWidget.vue?vue&type=style&index=0&id=e4d4baee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d4baee",
  null
  
)

export default component.exports